import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { UserCard } from "components/UserCard/UserCard.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { Redirect } from 'react-router-dom';
import avatar from "assets/img/faces/face-3.jpg";
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";
import FormErrors from "components/FormErrors/FormErrors.jsx";
import { WEB_URL } from "variables/Variables.jsx";

class UserProfile extends Component {
  constructor(props) {
      super(props);

      this.state = {
        runningAsyncOperation: false,
        formErrors: {email: '', password: ''},
        submitted : false,
        email: '',
        pass:''
      };

      this.emailInput = React.createRef(); 
      this.passInput = React.createRef(); 
  }

  componentDidMount () {
    this.logInUser(true);
  }

  handleLoginSubmit(e){
    e.preventDefault();
    this.setState({ runningAsyncOperation : true, submitted:true });
    this.logInUser()
    return false;
  }

  logInUser = (ignoreErrors) => {
    let fieldValidationErrors = this.state.formErrors;

    fetch("https://"+WEB_URL+"/account/api/login",{
      'method' : 'POST',
      'headers' : { 'Content-Type' : 'application/json'},
      //'body' : 'email='+this.state.email+'&password='+this.state.pass+'&detail=true',
      'body' : JSON.stringify({'email':this.state.email,'password':this.state.pass,'detail':true}),
      //body : JSON.stringify({email : this.state.email, password : this.state.pass}),
      'credentials': 'same-origin'
    }).then(res => res.json())
      .then(
        (result) => {
          if(result.auth == 'AUTH_OK' && result.token){
            this.props.setLoggedIn(result,this.state.email);
          }else{
            this.props.setLoggedIn(false);    
            if(!ignoreErrors){
              fieldValidationErrors.Login = 'failed. Your username/password combination was incorrect.';
            }
            //this.props.triggerNotification('error','tc','Login failed. Your username/password combination was incorrect.');
            this.setState({ runningAsyncOperation : false });
          }
        },
        (error) => {
          this.props.setLoggedIn(false);
          if(!ignoreErrors){
            fieldValidationErrors.Login = 'failed. An error occurred when logging in. Please contact us if the problem persists. ';
          }
          // this.props.triggerNotification('error','tc','Login failed. An error occurred when logging in. Please contact us if the problem persists. ');
          this.setState({ runningAsyncOperation : false });
        }
      )
  }

  handleUserInput (e) {
    const name = e.target.name;
    const value = e.target.value;
    const targetField = e.target;

    this.setState({[name]: value});
  }

  validateField(fieldName, value, targetField) {
    let fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;
    let passwordValid = this.state.passwordValid;
  
    switch(fieldName) {
      case 'email':
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if(!emailValid){
          fieldValidationErrors.email = emailValid ? '' : ' is invalid';
        }
        break;
      case 'pass':
        passwordValid = value.length;
        if(!passwordValid){
          fieldValidationErrors.password = passwordValid ? '': ' is required';
        }
        break;
      default:
        break;
    }
    this.setState({formErrors: fieldValidationErrors,
                    emailValid: emailValid,
                    passwordValid: passwordValid
                  }, this.validateForm);
  }

  validateForm() {
    this.setState({formValid: this.state.emailValid && this.state.passwordValid});
  }

  render() {
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={8}>
              <Card
                title=""
                content={
                  <form>
                    <FormInputs
                      ncols={["col-md-12"]}
                      properties={[
                        {
                          label: "Email",
                          name: "email",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Email",
                          defaultValue: ""
                        }
                      ]}
                      inputRef = {(input) => this.emailInput = input }
                      onChange={(event) => this.handleUserInput(event)} 
                    />
                    <FormInputs
                      ncols={["col-md-12"]}
                      properties={[
                        {
                          label: "Password",
                          type: "password",
                          name: "pass",
                          bsClass: "form-control",
                          placeholder: "Password",
                          defaultValue: ""
                        }
                      ]}

                      inputRef = {(input) => this.passInput = input }
                      onChange={(event) => this.handleUserInput(event)} 
                    />
                    
                    <ProgressButton bsStyle="info" fill onClick={(e) => {this.handleLoginSubmit(e);}} type="submit" runningAsyncOperation={this.state.runningAsyncOperation}>
                      Login 
                    </ProgressButton>

                    <Button style={{marginLeft:10,borderWidth:0}} onClick={(e) => this.props.history.push('/home/forgotpassword')}>Forgot Your Password?</Button>

                    <div className="clearfix" />

                    <div style={{paddingTop:20, visibility: this.state.submitted ? 'visible' : 'hidden'}}>
                      <FormErrors formErrors={this.state.formErrors} />
                    </div>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default UserProfile;
